module.exports = __webpack_public_path__ + "static/first-9f25ee8bf6f26639af836234e5d237de.png";